import React, { useState } from "react";
import styles from "./Login.module.scss";
import { useNavigate } from "react-router-dom";
import toast from "components/shared/toast/toast";
import { emailRegex } from "utils/regex";
import { LOGIN } from "services/apiEndpoints";
import publicRequest from "services/publicRequest";
import LoginLayout from "components/layouts/loginlayout/LoginLayout";
import * as Yup from "yup";
import { combineClasses, requiredMessage } from "utils/utils";
import { Form, Formik } from "formik";
import FormikControl from "components/formikcontrols/FormikControl";
import Button from "components/shared/button/Button";
import { PATH } from "utils/constants";
import SelectRoleModal from "./../../shared/selectrolemodal/SelectRoleModal";
import LoadingText from "components/shared/loadingtext/LoadingText";
import { IconButton, InputAdornment, InputLabel, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { setuserProfile } from "@redux/slices/globalSlice";

const Login = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch()
  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const navigate = useNavigate();

  const dummyPermissionAdmin = [
    "ViewProjects",
    "ViewUsers",
    "ViewDashboard",
    "ViewRoles",
    "ViewPermissions",
    "ViewEntity",
  ];
  const dummyPermissionUser = ["ViewProjects", "ViewDashboard"];

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .required(requiredMessage("Email ID"))
      .matches(emailRegex, "Invalid email format!"),
    password: Yup.string().required(requiredMessage("Password")),
  });

  // const login = (values) => {
  //   // login api call here
  //   // using promise since no api present
  //   const p = new Promise((res,rej) => {
  //     setTimeout(() => {
  //       localStorage.setItem("token", "sample-token")
  //       localStorage.setItem("email", "pranil@gmail.com")
  //       // permission will come from backend
  //       localStorage.setItem("permission", JSON.stringify(dummyPermissionAdmin))
  //       navigate("/")
  //       res()
  //     }, 500);
  //   })
  //   return p
  // }

  const login = (values) => {
    return publicRequest.post(LOGIN, values).then((res) => {
      // console.log('res :>> ', res);
      const { profileUrl,  userId, token, role, access , allowPromptFeature } = res?.data?.data || {};
      localStorage.setItem("token", token);

      // console.log("userId :>> ", userId);
      localStorage.setItem(
        "currentUser",
        JSON.stringify({
          token,
          role: role,
          access: access,
          // role: userRole?.[0]?.roleId,
          // roleName: userRole?.[0]?.role?.roleName,
          // isOnlyUser,
          // isUserAndApprover,
          // permission: permission.map(({ id, permission: perm }) => ({
          //   id,
          //   permissionName: perm.actionName,
          //   entityId: perm.entity.id,
          //   entityName: perm.entity.entityName
          // })),
          userId: userId,
          userProfile : profileUrl,
          allowPromptFeature : allowPromptFeature || false,
          // isVip,
          // approverList,
        })
      );

      dispatch(setuserProfile(profileUrl))
      localStorage.setItem("email", values.email);
      //   dispatch(setFilterValues(getDefaultDates()))
      //   if (userRole?.[0]?.role?.roleName?.toLowerCase() === "admin" || userRole?.[0]?.role?.roleName?.toLowerCase() === "internaluser") {
      //     navigate("/")
      //     localStorage.setItem("currentRole", "admin")
      //   }
      //   // else if(values.email === "shandharod@yahoo.com") {
      //   //   navigate("/")
      //   //   localStorage.setItem("currentRole", "approver")
      //   // }
      //   else if (userRole?.[0]?.role?.roleName?.toLowerCase() === "developer") {
      //     console.log('developer role')
      //     localStorage.setItem("currentRole", "developer");
      //     navigate("/app-logger")
      //   }
      //   else if (!isUserAndApprover) {
      //     navigate("/")
      //     localStorage.setItem("currentRole", isOnlyUser ? "user" : "approver")
      //     dispatch(setCardLimitModalOpen(true))
      //   }
      //   else {
      //     setModalOpen(true)
      //     dispatch(setCardLimitModalOpen(true))
      //   }
      if (token) {
        navigate("/");
      } else {
        navigate("/login");
      }
    });
  };

  const handleSubmit = async (values) => {
    const p = login(values);
    await toast.promise(p, {
      loading: (
        <>
          Logging in
          <LoadingText
            style={{ alignSelf: "flex-end", paddingBottom: "2px" }}
          />
        </>
      ),
      success: () => "Login Successful",
      error: (err) =>{
      return   err?.response?.data?.error || err?.message || "Something went wrong"
    }});
  };

  // const handleSubmit = async (values) => {
  //   try {
  //     const res = publicRequest.post(LOGIN, values)
  //   } catch (e) {
  //     console.log('e :>> ', e);
  //   }

  // };

  const modalProps = {
    modalOpen,
    setModalOpen,
  };

  return (
    <>
      <SelectRoleModal {...modalProps} />
      <LoginLayout>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formik) => {
            return (
              <div className={styles.mainDiv}>
                <p className={styles.heading}>Welcome to TickrAi</p>
                <p className={styles.subHeading}>Let's sign in your account</p>
                <Form className={styles.form} autoComplete="off">
                  {/* <FormikControl
                    name="email"
                    control="input"
                    label="Email ID"
                    placeholder="Enter Email ID"
                    isRequired={true}
                    formik={formik}
                  /> */}
                  <InputLabel sx={{ fontSize: "14px", fontWeight: 600 }}>
                    Email ID<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <TextField
                    onChange={formik.handleChange}
                    value={formik.values.email}
                    onBlur={formik.handleBlur}
                    name="email"
                    size="small"
                    type="email"
                    margin="normal"
                    className={styles.marginTop2px}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        margin: 0,
                      },
                    }}
                    placeholder="Enter Email ID"
                    error={Boolean(formik.errors.email && formik.touched.email)}
                    helperText={
                      formik.errors.email &&
                      formik.touched.email &&
                      String(formik.errors.email)
                    }
                    fullWidth
                  />
                  {/* <FormikControl
                    name="password"
                    control="password"
                    type="password"
                    label="Password"
                    placeholder="Enter Password"
                    isRequired={true}
                  /> */}
                  <InputLabel sx={{ fontSize: "14px", fontWeight: 600 }}>
                    Password<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <TextField
                    onChange={formik.handleChange}
                    value={formik.values.password}
                    onBlur={formik.handleBlur}
                    name="password"
                    size="small"
                    type={showPassword ? "text" : "password"}
                    margin="normal"
                    className={styles.marginTop2px}
                    placeholder="Enter Password"
                    error={Boolean(
                      formik.errors.password && formik.touched.password
                    )}
                    sx={{
                      "& .MuiFormHelperText-root": {
                        margin: "2px 0px",
                      },
                    }}
                    helperText={
                      formik.errors.password &&
                      formik.touched.password &&
                      String(formik.errors.password)
                    }
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleTogglePasswordVisibility}
                            edge="end"
                            aria-label="toggle password visibility"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Button
                    type="submit"
                    className={styles.button}
                    disabled={formik.isSubmitting}
                  >
                    {formik.isSubmitting ? "Loggin in..." : "Login"}
                  </Button>
                  {/* <p className={styles.bottomText}>
                    Don't have an account? <span
                      className="link-text"
                      onClick={() => navigate(PATH.publicRoutes.REGISTER.path)}
                    >
                      Sign up
                    </span>
                  </p> */}
                  <p
                    className={combineClasses(styles.bottomText, "link-text")}
                    onClick={() =>
                      navigate(PATH.publicRoutes.FORGOT_PASSWORD.path)
                    }
                  >
                    Forgot Password?
                  </p>
                </Form>
              </div>
            );
          }}
        </Formik>
      </LoginLayout>
    </>
  );
};

export default Login;
